module.exports = __webpack_public_path__ + "img/微信视频号.b043a169.png";